'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_LoginPageView$$anon$23() {
  this.b7p = null;
  this.b7q = false;
}
export { $c_Lpresto_LoginPageView$$anon$23 as $c_Lpresto_LoginPageView$$anon$23 };
$p = $c_Lpresto_LoginPageView$$anon$23.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_LoginPageView$$anon$23;
/** @constructor */
function $h_Lpresto_LoginPageView$$anon$23() {
}
export { $h_Lpresto_LoginPageView$$anon$23 as $h_Lpresto_LoginPageView$$anon$23 };
$h_Lpresto_LoginPageView$$anon$23.prototype = $p;
$p.P = (function() {
  if ((!this.b7q)) {
    this.b7p = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_T3($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Some($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$()), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Some($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$()));
    this.b7q = true;
  }
  return this.b7p;
});
var $d_Lpresto_LoginPageView$$anon$23 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_LoginPageView$$anon$23, "presto.LoginPageView$$anon$23", ({
  Mn: 1,
  a: 1,
  i: 1
}));
export { $d_Lpresto_LoginPageView$$anon$23 as $d_Lpresto_LoginPageView$$anon$23 };
//# sourceMappingURL=presto.-Login-Page-View$$anon$23.js.map
